import React, { useState, useEffect, useCallback } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import LoginLogo from '../../Assets/images/Frame 39059 1.png';
import LoginImg from '../../Assets/images/Registra.png';
import SignupBackground from '../../Assets/images/SignupBackground.png';
import { useNavigate, useLocation } from 'react-router-dom'; // Import useNavigate for navigation
import Swal from 'sweetalert2';
import apiClient from '../../Api/apiClient';
import useApiClient from '../../Api/apiClient';
import { API_BASE_URL } from '../../Api/config';
const LoginAffiliator = ({ onLogin }) => {
  // const apiClient = useApiClient();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [userName, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const location = useLocation();
  const { PricingBeforLogin, FromCheckoutAlert } = location.state || {};
  const [errors, setErrors] = useState({});
  const navigate = useNavigate(); // Initialize the navigate function
  const [rememberMe, setRememberMe] = useState(false);
  const [countryCode, setCountryCode] = useState('88');
  const [matchedPhone, setMatchedPhone] = useState(false);
  const handleSignUpClick = () => {
    navigate('/signup', {
      state: {
        PricingBeforLogin: PricingBeforLogin,
        FromCheckoutAlert: FromCheckoutAlert,
        RegiClickFromAffiliator: 'RegiClickFromAffiliator',
      },
    }); // Navigate to the signup page
  };

  // console.log(FromCheckoutAlert);

  // useEffect to retrieve stored credentials on mount
  useEffect(() => {
    const savedUsername = localStorage.getItem('userName');
    const savedPassword = localStorage.getItem('password');
    const savedRememberMe = localStorage.getItem('rememberMe') === 'true';

    // console.log('Saved phone:', savedPhone);
    // console.log('Saved password:', savedPassword);
    // console.log('Saved rememberMe:', savedRememberMe);

    if (savedUsername && savedPassword && savedRememberMe) {
      setUsername(savedUsername);
      setPassword(savedPassword);
      setRememberMe(savedRememberMe);
    }
  }, []);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const validateForm = () => {
    const newErrors = {};
    if (!userName) {
      newErrors.userName = 'User name is required';
    }
    if (!password) {
      newErrors.password = 'Password is required';
    }
    return newErrors;
  };

  const handleLogin = async () => {
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length !== 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      const payload = { phone: userName, password };
      const response = await apiClient.post(
        '/auth/affiliator/sign-in',
        payload
      );
      // console.log("Login response:",response.data);
      // const {
      //   token,
      //   data: { otp_status, user_type },
      // } = response.data;
      // localStorage.setItem('bearer', token);
      // localStorage.setItem('user_type', user_type);

      const {
        token: bearer,
        data: { user_type, otp_status },
      } = response.data;

      // Store token and user details in localStorage
      localStorage.setItem('bearer', bearer);
      localStorage.setItem('user_type', user_type);

      if (otp_status === 1) {
        onLogin();
        navigate('/affiliator-dashboard');
        window.scrollTo(0, 0);
      } else {
        try {
          const response = await apiClient.post(
            '/auth/affiliator/resend-otp',
            { phone: userName },
            { withCredentials: true }
          );
          const successMessage = response.data.message;
          Swal.fire({
            title: 'Verify OTP',
            // text: 'You need to verify your OTP to proceed.',
            text: successMessage,
            confirmButtonText: 'Verify Now',
            customClass: {
              popup: 'w-72 h-auto p-3',
              title: 'text-lg',
              content: 'text-xs',
              confirmButton:
                'bg-DefaultColor text-white px-4 py-1 text-sm rounded-md',
            },
          });
          // Redirect to OTP verification page with phone number in state
          navigate('/verify-affiliator-otp', {
            state: {
              // phone: `${countryCode}${userName}`,
              phone: userName,
              PricingBeforLogin: PricingBeforLogin,
              userType: 'affiliator',
            },
          });
        } catch (error) {
          console.error('Error resending OTP:', error);
          const errorMessage = error.response?.data?.message;
          Swal.fire({
            title: 'Error',
            text: errorMessage,
            confirmButtonText: 'Okay',
            customClass: {
              popup: 'w-72 h-auto p-3',
              title: 'text-lg',
              content: 'text-xs',
              confirmButton:
                'bg-DefaultColor text-white px-4 py-1 text-sm rounded-md',
            },
          });
          return;
        }
        navigate('/verify-affiliator-otp', {
          state: { phone: userName, user_type: user_type },
        });
      }
    } catch (error) {
      console.error('Login failed:', error);
      const errorMessage =
        error.response?.data?.message || 'An unknown error occurred';
      Swal.fire({
        title: 'Failed!',
        text: errorMessage,
        confirmButtonText: 'Okay',
        customClass: {
          popup: 'w-72 h-auto p-3',
          title: 'text-lg',
          content: 'text-xs',
          confirmButton:
            'bg-DefaultColor text-white px-4 py-1 text-sm rounded-md',
        },
      });
    }
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      handleLogin();
    }
  };

  const checkUserExists = async phone => {
    try {
      // Step 1: Search with user_type = "user"
      let queryParams = new URLSearchParams();
      if (phone) queryParams.append('key', phone);
      queryParams.append('user_type', 'affiliator');

      let response = await apiClient.get(
        `${API_BASE_URL}/user/visitor/users?${queryParams.toString()}`
      );

      // If data is found with user_type = "user", return true
      if (response.data?.data && response.data.data.length > 0) {
        const userData = response.data.data[0];
        if (userData.phone === phone || userData.email === phone) {
          return true;
        }
      }

      // // Step 2: If no data is found with user_type = "user", search with end_user_type = "end_user"
      // queryParams = new URLSearchParams();
      // if (phone) queryParams.append('phone', phone);
      // queryParams.append('end_user_type', 'end_user');

      // response = await apiClient.get(
      //   `${API_BASE_URL}/user/visitor/users?${queryParams.toString()}`
      // );

      // // If data is found with end_user_type = "end_user", return true
      // if (response.data?.data && response.data.data.length > 0) {
      //   const userData = response.data.data[0];
      //   if (userData.phone === phone) {
      //     return true;
      //   }
      // }

      // If no data is found in either search, return false
      return false;
    } catch (error) {
      console.error('Error checking user details:', error);
      return false;
    }
  };

  // Debounce function
  const debounce = (func, delay) => {
    let timeoutId;
    return function (...args) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  };

  const checkUserDetails = async username => {
    if (username) {
      const phoneNumber = `${username}`;
      const phoneExists = await checkUserExists(phoneNumber);

      if (phoneExists) {
        setErrors(prevErrors => ({
          ...prevErrors,
          userName: '',
        }));
        setMatchedPhone(true);
      } else {
        setErrors(prevErrors => ({
          ...prevErrors,
          userName: 'No account found. Please register.',
        }));
        setMatchedPhone(false);
      }
    }
  };

  const debouncedCheckUserDetails = useCallback(
    debounce(username => {
      checkUserDetails(username);
    }, 500),
    []
  );

  useEffect(() => {
    debouncedCheckUserDetails(userName);
  }, [userName, debouncedCheckUserDetails]);


  const isFormValid = userName && password;
  const isButtonDisabled = !matchedPhone || !isFormValid;
  

  return (
    <div
      className="flex items-center justify-center min-h-screen md:py-16 py-10 md:mt-10 mt-0 px-2"
      style={{ backgroundImage: `url(${SignupBackground})` }}
    >
      <div className="md:p-10 p-2 items-center justify-center flex flex-col lg:flex-row md:gap-10 rounded-lg border">
        {/* left section */}
        <div className="lg:w-1/2 w-full p-6 flex flex-col items-center justify-center">
          <img
            src={LoginLogo}
            alt="LoginLogo"
            className="h-10 lg:h-16 mb-0 md:pl-0 lg:mb-0"
          />
          <h1 className="text-sm text-gray-600 text-center mb-2">
            Log in to your Affiliate account
          </h1>
          <img
            src={LoginImg}
            alt="LoginImg"
            className="md:h-48 w-72 h-32 md:block hidden"
          />
        </div>

        {/* right section */}
        <div className="lg:w-1/2 w-full p-4">
          <h2 className="text-lg text-center lg:text-xl font-semibold md:-mt-0 -mt-6 mb-1">
            Log in
          </h2>
          <p className="mb-0 text-xs text-center ">
            Don't have an account?
            <button
              onClick={handleSignUpClick}
              className="font-semibold ml-2 bg-DefaultColor text-white hover:underline  hover:bg-DefaultHoverColor  px-2 py-0.5 text-xs rounded-md transition-all duration-300 ease-in-out transform hover:scale-105"
            >
              Registration
            </button>
          </p>
          <div className="space-y-2 mt-2">
            {/* Input Fields */}
            <div className="flex flex-col space-y-2">
              <div className="flex space-x-1">
                <input
                  type="text"
                  placeholder="Email or Phone with country code"
                  className="border text-xs border-gray-300 rounded-md py-2 px-2 w-full"
                  value={userName}
                  onChange={e => setUsername(e.target.value)}
                  onKeyDown={handleKeyDown}
                />
              </div>
              {errors.userName && !matchedPhone && (
                <p className="text-red-500 text-xs mb-0 -mt-2">
                  {errors.userName}{' '}
                  <button
                    onClick={handleSignUpClick}
                    className="text-blue-500 hover:underline"
                  >
                    Register Now
                  </button>
                </p>
              )}

              {matchedPhone && (
                <p className="text-green-500 text-xs mb-0 -mt-2">
                  Username matched successfully.
                </p>
              )}

              <div className="relative ">
                <input
                  type={passwordVisible ? 'text' : 'password'}
                  placeholder="Password"
                  className="border text-xs border-gray-300 rounded-md py-2 px-4 w-full"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  onKeyDown={handleKeyDown}
                />
                <button
                  type="button"
                  onClick={togglePasswordVisibility}
                  className="absolute inset-y-0 right-0 flex items-center px-3 focus:outline-none"
                >
                  {passwordVisible ? <FaEyeSlash /> : <FaEye />}
                  <span className="ml-1 text-xs">
                    {passwordVisible ? 'Hide' : 'Show'}
                  </span>
                </button>
              </div>
              {errors.password && (
                <p className="text-red-500 text-xs mb-0 -mt-2">
                  {errors.password}
                </p>
              )}
            </div>
            {/* remember me and forgot password */}
            <div className="flex justify-between items-center">
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="remember-me"
                  checked={rememberMe}
                  onChange={() => setRememberMe(prev => !prev)}
                  className="mr-1 ml-1"
                />
                <label htmlFor="remember-me" className="text-xs text-gray-500">
                  Remember Me
                </label>
              </div>
              <button
                // onClick={() => navigate('/forgotaffiliate')}
                onClick={() =>
                  navigate('/forgotPassword', {
                    state: { forgotFromAffiliator: 'forgotFromAffiliator' },
                  })
                }
                className="text-xs text-gray-500 hover:underline"
              >
                Forgot Password?
              </button>
            </div>

            {/* Create Account Button */}
            <button
              onClick={handleLogin}
              className={`w-full bg-EntryBG text-white py-1.5 px-6  mb-1 mt-2 rounded-md ${isButtonDisabled ? 'bg-gray-300 ' : 'bg-blue-500 hover:bg-btnHover cursor-pointer'}`}
              disabled={isButtonDisabled}
            >
              Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginAffiliator;
